import React from "react";

const WorkflowNode = ({
  label,
  sublabel,
  color = "blue",
  icon,
}: {
  label: string;
  sublabel: string;
  color?: "orange" | "blue" | "green";
  icon: React.ReactNode;
}) => {
  const colorMap = {
    orange: "bg-orange-900/40 border-orange-700/50 text-orange-400",
    blue: "bg-blue-900/40 border-blue-700/50 text-blue-400",
    green: "bg-green-900/40 border-green-700/50 text-green-400",
  };

  return (
    <div className="flex items-center gap-3 p-3 bg-neutral-900 rounded-xl border border-neutral-800">
      <div
        className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 border ${colorMap[color]}`}
      >
        {icon}
      </div>
      <div className="min-w-0">
        <p className="text-[11px] font-semibold text-neutral-200 leading-tight">
          {label}
        </p>
        <p className="text-[10px] text-neutral-500 leading-tight">{sublabel}</p>
      </div>
    </div>
  );
};

const Arrow = () => (
  <div className="flex justify-center my-1">
    <svg
      className="w-4 h-4 text-neutral-600"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M19 9l-7 7-7-7"
      />
    </svg>
  </div>
);

export const SkeletonThree = () => {
  return (
    <div className="relative flex py-8 px-2 h-full">
      <div className="w-full p-5 mx-auto bg-neutral-950 shadow-2xl group rounded-2xl border border-neutral-800">
        {/* Header */}
        <div className="flex items-center gap-2 mb-4">
          <div className="w-2 h-2 rounded-full bg-blue-500" />
          <span className="text-[10px] text-neutral-400 font-medium uppercase tracking-wider">
            Workflow · Post-Call
          </span>
        </div>

        {/* Workflow nodes */}
        <div className="space-y-0">
          <WorkflowNode
            label="Call Outcome: Interested"
            sublabel="Trigger"
            color="orange"
            icon={
              <svg
                className="w-4 h-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 10V3L4 14h7v7l9-11h-7z"
                />
              </svg>
            }
          />
          <Arrow />
          <WorkflowNode
            label="Send pricing email"
            sublabel="Action · Email"
            color="blue"
            icon={
              <svg
                className="w-4 h-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
            }
          />
          <Arrow />
          <WorkflowNode
            label="Move to Negotiation"
            sublabel="Action · Pipeline"
            color="green"
            icon={
              <svg
                className="w-4 h-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                />
              </svg>
            }
          />
        </div>

        {/* Footer */}
        <div className="mt-4 pt-3 border-t border-neutral-800 flex items-center justify-between">
          <span className="text-[10px] text-neutral-600">No code required</span>
          <span className="text-[10px] text-green-500">Active</span>
        </div>
      </div>
    </div>
  );
};
